
import Icon from 'JS/components/Icon.vue';
import IconBadge from '../IconBadge.vue';
import { defineComponent } from 'vue';
import { IHeaderJson } from 'Src/js/types/Header';
import { PropType } from 'vue';

export default defineComponent({
	name: 'HeaderCartDropdown',
	components: {
		Icon,
		IconBadge,
	},
	props: {
		headerData: { type: Object as PropType<IHeaderJson>, required: true },
	},
	setup() {
		const isSSR = (typeof window === 'undefined');
		return {
			isSSR
		};
	}
});
